import { useQuery } from '@tanstack/react-query';
import { getMetadata } from '@/api/profile';

/**
 * Hook to fetch and cache metadata
 * - Prefetches on app start
 * - Caches for 1 hour
 * - Shared across all components using the same queryKey
 */
export const useMetadata = () => {
  return useQuery({
    queryKey: ['metadata'],
    queryFn: getMetadata,
    staleTime: 60 * 60 * 1000, // 1 hour - data is considered fresh for 1 hour
    gcTime: 2 * 60 * 60 * 1000, // 2 hours - keep in cache for 2 hours (formerly cacheTime)
    // Prefetch on mount even if not immediately used
    // This ensures data is available when needed
    refetchOnMount: false, // Don't refetch if data exists in cache
    refetchOnWindowFocus: false, // Don't refetch on window focus
    retry: 2, // Retry 2 times on failure
  });
};

